import { ADD_PRODUCT, DECREMENT_PRODUCT, INCREMENT_PRODUCT } from "./actionType";

export const incrementProduct = (product) => {
    return {
        type: INCREMENT_PRODUCT,
        payload: product,
    };
};

export const decrementProduct = (product) => {
    return {
        type: DECREMENT_PRODUCT,
        payload: product,
    };
};

export const addProduct = (product) => {
    return {
        type: ADD_PRODUCT,
        payload: product,
    };
}
